import { Modal } from 'react-bootstrap';
import { PreviousBookingLogin } from './PreviousBookingLogin';
import t from '../../../text';

export const PreviousBookingLoginModal = ({ show, onClose }) => (
  <Modal show={show} onHide={onClose} centered dialogClassName="login-modal">
    <Modal.Header closeButton className="bg-lighter">
      <Modal.Title>
        <strong>{t('myBooking.login.title')}</strong>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <PreviousBookingLogin onClose={onClose} />
    </Modal.Body>
  </Modal>
);
